// Pure helpers of the Billing & reminders card (BizcalPolicyCard.tsx), kept out of the .tsx so the
// server test of package proptax (server/src/scripts/testProptax.ts) runs the very same code.
import type { PolicyAdmin, PolicyKey } from '../../utils/api/bizcal';

type Vals = Partial<Record<PolicyKey, string>>;
type Shape = Pick<PolicyAdmin, 'fields' | 'defaults'>;

/** A field with no product default (the property-tax fee per property and due date: the firm's own
 *  price and date). Emptying it does not restore a default — it switches the setting off. */
export const noDefault = (data: Shape, key: PolicyKey): boolean => data.defaults[key] == null;

/** "Clear all (use defaults)": empty every field that HAS a product default. A field without one keeps
 *  its value untouched; it can still be emptied on its own, field by field. */
export const clearToDefaults = (data: Shape, vals: Vals): Vals => {
  const out: Vals = {};
  for (const f of data.fields) if (noDefault(data, f.key) && vals[f.key] != null) out[f.key] = vals[f.key];
  return out;
};

/** Does this card show a field that "Clear all" keeps? (then the button says so in its tooltip) */
export const keepsSomeOnClear = (data: Shape): boolean => data.fields.some(f => noDefault(data, f.key));
